<template>
  <slot :selectedTab="selectedTab" :overflown="overflown" :changeTab="changeTab" :scrollTabs="scrollTabs"></slot>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'

const props = defineProps({
  // Map of anchor id -> tab index, e.g. { 'in-person-events': 0, 'events-by-date': 1 }
  anchors: {
    type: Object,
    default: () => ({}),
  },
})

const selectedTab = ref(0)
const overflown = ref(false)
let tabList = null

function changeTab(event) {
  if (event.target) {
    selectedTab.value = event.target.selectedIndex
  } else {
    selectedTab.value = event
  }

}

function isOverflown({ clientWidth, clientHeight, scrollWidth, scrollHeight }) {
  overflown.value = scrollHeight > clientHeight || scrollWidth > clientWidth;
}

function scrollTabs() {
  tabList.scrollTo(9999, 0)
}

// Open the tab that owns the anchor in the URL, then scroll to it.
// Runs on load (no hashchange fires for a hash that's already in the URL)
// and on every subsequent in-page anchor click.
function syncTabToHash() {
  const id = decodeURIComponent(window.location.hash.replace('#', ''))
  if (!id) return

  const index = props.anchors[id]
  if (index === undefined) return

  selectedTab.value = index

  // Wait for the panel to actually render before scrolling to it
  nextTick(() => {
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    })
  })
}

onMounted(() => {
  tabList = document.querySelector('.tab-list')
  isOverflown(tabList)

  window.addEventListener('resize', () => {
    isOverflown(tabList)
  })

  window.addEventListener('hashchange', syncTabToHash)
  syncTabToHash()
})

onUnmounted(() => {
  window.removeEventListener('hashchange', syncTabToHash)
})
</script>
